export default __webpack_public_path__ + "static/media/Facebook-02.2b99f48b.svg";